export default __webpack_public_path__ + "static/media/green.19074056.webp";